module.exports = __webpack_public_path__ + "img/rec-12.377f3a60.png";